import styled from '@emotion/styled';
import { ButtonBase, type ButtonBaseProps } from '@mui/material';
import FileChipFilename from '../FileChip/FileChipFilename';

const LinkButton = (props: ButtonBaseProps) => (
  <ButtonBase component="a" {...props} />
);

const ExternalFileFilenameAndLink = styled(
  FileChipFilename.withComponent(LinkButton),
)<ButtonBaseProps<'a'>>(({ theme }) => ({
  marginLeft: 3,
  paddingLeft: 3,
  color: 'inherit',
  transition: theme.transitions.create(['background-color']),
  ':hover': {
    backgroundColor: theme.palette.action.hover,
    textDecoration: 'underline',
  },
  ':focus': {
    backgroundColor: theme.palette.action.selected,
    textDecoration: 'underline',
  },
}));

export default ExternalFileFilenameAndLink;
